import { render, staticRenderFns } from "./resetPass.vue?vue&type=template&id=c19e99a4"
import script from "./resetPass.vue?vue&type=script&lang=js"
export * from "./resetPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports